import api from "./api.js";
import BreadCrumbs from "../../components/BreadCrumbs.vue";
export default {
    components: {
        BreadCrumbs
    },
    methods: {
        generateDate(date) {
            const d = new Date(date);
            return d.toDateString() + " " + d.toLocaleTimeString();
        },share(link) {
            window.open(link, "_blank");
        }
    },
    mounted() {
        api
            .getNewEventDetails(this.$route.params.neid.split("-").pop())
            .then((res) => {
                if (res.data.responseCode === 1) {
                    this.newEvent = res.data.data;
                    this.breadCrumbs.push(
                        {
                            text: this.newEvent.title,
                            exact: true, to: this.$func.generateNewLink(this.newEvent),
                        },
                    )
                }
            });
    },
    data: () => ({
        // For Filters
        newEvent: {
        },
        breadCrumbs: [
            {
                text: "Home",
                exact: true,
                to: "/",
            },
            {
                text: "News And Events",
                exact: true,
                to: "/news-and-events",
            },

        ],
    }),
};